module.exports = __webpack_public_path__ + "static/media/Clouds-66.7s-1920px.df717d9e.svg";